import { Component, OnInit, forwardRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { RouteHistorySubTab } from '../../pillar/layout/route-history-sub-tab';
import { RouteHistoryService } from '../../pillar/layout/route-history.service';
import { TileContainer } from '../../pillar/dashboard/services/TileContainer';
import { CurrentUserService } from '../../security/services/CurrentUserService';
import { AppConfigurationService } from '../../core/services/AppConfigurationService';

@Component({
  selector: 'brd-configuration-dashboard',
  providers: [{ provide: TileContainer, useExisting: forwardRef(() => ConfigurationDashboardComponent) }],
  templateUrl: './configuration-dashboard.component.html',
  styleUrls: ['./configuration-dashboard.component.scss']
})
export class ConfigurationDashboardComponent extends TileContainer implements OnInit {
  static dashboardName = 'configuration';
  checked: boolean = false;
  currentTab: string = null;
  isUsingVms: boolean = false;

  viewVocabularyVersionsPermission: string = 'VocabularyModule.CodeSystem:View';
  viewRulesPermission: string = 'RuleModule.BusinessRule:View';
  viewDynamicDataSetsPermission: string = 'DynamicDataSetModule.DynamicDataSets:View';

  @ViewChild('tabGroup')
  tabGroup: MatTabGroup;

  get name(): string {
    return ConfigurationDashboardComponent.dashboardName;
  }

  get tab(): string {
    return this.currentTab;
  }

  constructor(private changeDetectorRef: ChangeDetectorRef,
    public historyService: RouteHistoryService,
    private currentUserService: CurrentUserService,
    private appConfigurationService: AppConfigurationService) {
    super();
    this.isUsingVms = appConfigurationService.configuration.isUsingVms;
  }

  tabClick( event: any ) {
    this.currentTab = event.tab.textLabel;
    var currTab = new RouteHistorySubTab(this.name, event.tab.textLabel, event.index);
    this.historyService.setLastSubTab(currTab);
  }

  toggleChange() {
    this.checked = !this.checked;
  }

  ngAfterViewInit() {
    if(this.historyService.lastSubTab && this.historyService.lastSubTab.moduleName == this.name){
      this.currentTab = this.historyService.lastSubTab.tabName;
      this.tabGroup.selectedIndex = this.historyService.lastSubTab.tabIndex;
    } else {
      this.currentTab = this.tabGroup._tabs.first.textLabel;
    }
    this.changeDetectorRef.detectChanges();
  }

  ngOnInit() {
  }

  hasPermission(permission: string) {
    return this.currentUserService.hasPermission(permission);
  }
}



// WEBPACK FOOTER //
// ./src/app/configuration/components/configuration-dashboard.component.ts